import { useWalletModal } from '@solana/wallet-adapter-react-ui';
import { FC } from 'react';

export const ConnectButtonOnClick: FC<{}> = () => {
  const { visible, setVisible } = useWalletModal();

  return (
    <div className="md:px-5 lg:px-0">
      <button className="w-full px-3 md:px-6  py-3 rounded bg-[#1A1C28] shadow-btn-inner text-[#E8E9EE] tracking-[0.32px] group relative cursor-pointer">
        <div
          className="flex text-nowrap whitespace-nowrap break-keep items-center justify-center gap-1 text-md uppercase cursor-pointer"
          onClick={() => setVisible(true)}
        >
          Connect
        </div>
      </button>
    </div>
  );
};
